import type { LeaderboardApprover } from "./DraftLeaderboardPanel";
import type { AdminUser } from "../../Store/Reducers/MasterSlice";
import {
  ROLE_DISPLAY_NAMES,
  ROLES,
  normalizeRoleName,
} from "../../Utils/Constants/RoleConstants";

const CONFIGURED_LEADERBOARD_APPROVER_ROLES = new Set<string>([
  "executive_lead",
  "executive_leader",
  ROLES.VENDOR_ADMIN,
  ROLES.EXECUTIVE_SPONSOR_LEAD,
]);

type LoggedInApproverUser = {
  role?: string | null;
  executiveOpsApprove?: boolean;
};

/** Org-level approver access (Vendor Admin APPROVER ACCESS or Select Approver pool). */
export function isConfiguredLeaderboardApprover(
  user: LoggedInApproverUser | null | undefined
): boolean {
  if (!user) return false;
  const role = normalizeRoleName(user.role);
  if (role && CONFIGURED_LEADERBOARD_APPROVER_ROLES.has(role)) return true;
  return user.executiveOpsApprove === true;
}

export function mapAdminUserToLeaderboardApprover(
  user: AdminUser
): LeaderboardApprover {
  const roleName =
    typeof user.role === "string" ? user.role : (user.role?.name ?? "");
  const normalizedRole = normalizeRoleName(roleName);
  const roleLabel =
    ROLE_DISPLAY_NAMES[normalizedRole as keyof typeof ROLE_DISPLAY_NAMES] ||
    roleName.replace(/_/g, " ") ||
    "";

  return {
    user_id: user.user_id,
    full_name: user.full_name,
    position: user.position,
    email: user.email,
    role_label: roleLabel,
  };
}

export function leaderboardApproverOptionLabel(
  approver: LeaderboardApprover
): string {
  const role = approver.role_label ? ` · ${approver.role_label}` : "";
  const title = approver.position ? ` · ${approver.position}` : "";
  return `${approver.full_name || "—"}${role}${title}`;
}
